import { useQuery } from '@tanstack/react-query';
import { executeGraphql } from '../graphql/execute';
import { GetModuleSlugs, GetSlugs } from '../graphql/queries/slugs';

export const useSlugs = () => {
  return useQuery({
    queryKey: ['slugs'],
    queryFn: () => executeGraphql(GetSlugs, undefined, true),
  });
};
export const useModuleSlugs = () => {
  return useQuery({
    queryKey: ['module-slugs'],
    queryFn: () => executeGraphql(GetModuleSlugs, undefined, true),
  });
};
